angular.module('app').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/app/views/aboutsettings.html',
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-12\">\r" +
    "\n" +
    "        <div id=\"about-settings\" class=\"form-section\" ng-cloak>\r" +
    "\n" +
    "            <div class=\"form-section-header\" translate>\r" +
    "\n" +
    "                About Aprima NOW\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'Client ID' | translate }}:<br/>\r" +
    "\n" +
    "                    <span id=\"client-id\">{{::clientID}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'Version' | translate }}:<br/>\r" +
    "\n" +
    "                    <span id=\"versionNumber\">{{::versionNumber}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'Version Code' | translate}}:<br/>\r" +
    "\n" +
    "                    <span title=\"{{::gitCommitHash}}\">{{::gitCommitHashShort}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'Device Id' | translate}}:<br/>\r" +
    "\n" +
    "                    <span id=\"deviceId\">{{::deviceId}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'Server Version' | translate}}:<br/>\r" +
    "\n" +
    "                    <span id=\"serverVersion\">{{::serverVersion}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'PRM Server Version' | translate}}:<br/>\r" +
    "\n" +
    "                    <span id=\"prmServerVersion\">{{::prmVersion}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'PRM Database Version' | translate}}:<br/>\r" +
    "\n" +
    "                    <span id=\"prmDatabaseVersion\">{{::databaseVersion}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    {{::'PRM Database Build' | translate}}:<br/>\r" +
    "\n" +
    "                    <span id=\"prmDatabaseBuild\">{{::databaseBuild}}</span>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/appointmentlistsettings.html',
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-12\">\r" +
    "\n" +
    "        <div class=\"form-section\" ng-cloak>\r" +
    "\n" +
    "            <div class=\"form-section-header\" translate>\r" +
    "\n" +
    "                Schedule Settings\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label class=\"control-label\" for=\"appointment-calendar\" translate>Schedule Calendar</label>\r" +
    "\n" +
    "                    <select id=\"appointment-calendar\" name=\"appointment-calendar\"\r" +
    "\n" +
    "                            class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                            data-ng-model=\"settings.appointmentsCalendar\"\r" +
    "\n" +
    "                            data-ng-options=\"calendar.Description for calendar in apptOptions.calendars\"\r" +
    "\n" +
    "                            ng-change=\"saveAppointmentsTileSettings()\"></select>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <input type=\"checkbox\" name=\"hideDischarged\" id=\"hideDischarged\"\r" +
    "\n" +
    "                           data-ng-model=\"settings.hideDischarged\" ng-change=\"saveHideDischargedOption()\">\r" +
    "\n" +
    "                    <label for=\"hideDischarged\" translate>Hide Discharged Appointments</label>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                &nbsp;\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <input type=\"checkbox\" name=\"display-end-times\" id=\"display-end-times\"\r" +
    "\n" +
    "                           data-ng-model=\"settings.displayEndTime\" ng-change=\"saveAppointmentsTileSettings()\">\r" +
    "\n" +
    "                    <label for=\"display-end-times\" translate>Display End Times</label>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/components/apPatientPortal.html',
    "<div ng-if=\"!vm.loadedAngular\">\r" +
    "\n" +
    "    <ap-force-load-angular (angular-initialized)=\"vm.onAngularInitialized()\" />\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-if=\"vm.loadedAngular\">\r" +
    "\n" +
    "    <ap-header ng-if=\"!vm.shouldHideToolbar()\"></ap-header>\r" +
    "\n" +
    "    <ap-toolbar ng-if=\"!vm.shouldHideToolbar()\"></ap-toolbar>\r" +
    "\n" +
    "    <ap-mobile-nav ng-if=\"!vm.shouldHideToolbar()\"></ap-mobile-nav>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-class=\"(vm.shouldHideToolbar())?'ap-main-content':'ap-main-content-toolbar'\">\r" +
    "\n" +
    "        <div\r" +
    "\n" +
    "            id=\"main-content\"\r" +
    "\n" +
    "            ng-class=\"!vm.isLoginView() ? 'ap-application-margin ap-application-content' : 'container-fluid container-flush'\"\r" +
    "\n" +
    "            ui-view>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<!--    The order of these toaster/ngx-toasta containers affects the z order of them,-->\r" +
    "\n" +
    "<!--    meaning the last one will be on top (if there was an active toast in both at the same time).-->\r" +
    "\n" +
    "<!--    Although, I don't actually know when that case would happen. -->\r" +
    "\n" +
    "        <ngx-toasta></ngx-toasta>\r" +
    "\n" +
    "        <toaster-container toaster-options=\"{}\"></toaster-container>\r" +
    "\n" +
    "        <ap-footer ng-if=\"!vm.shouldHideFooter()\"></ap-footer>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/components/apPrintablePracticeInfo.html',
    "<div class=\"visible-print-block\">\r" +
    "\n" +
    "    {{::vm.practiceName}}\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/directives/apDynamicFrame.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div>\r" +
    "\n" +
    "        <iframe id=\"docFrame\"\r" +
    "\n" +
    "                width=\"100%\"\r" +
    "\n" +
    "                iframe-onload=\"reload('docFrame')\"\r" +
    "\n" +
    "                src=\"{{loadingUrl}}\"></iframe>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/directives/apFormAttachment.html',
    "\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-xs-flush col-md-7\">\r" +
    "\n" +
    "            <ap-select-file id=\"apSelectFile\" name=\"apSelectFile\"\r" +
    "\n" +
    "                            selected-file-name=\"selectDocumentModel.selectedFileName\"\r" +
    "\n" +
    "                            selected-file-contents=\"selectDocumentModel.selectedFileContents\"\r" +
    "\n" +
    "                            selected-mime-type=\"selectDocumentModel.selectedMimeType\"\r" +
    "\n" +
    "                            validation-message=\"selectDocumentModel.validationMessage\"\r" +
    "\n" +
    "                            practice-form=\"practiceForm\"\r" +
    "\n" +
    "                            sending = \"sending\">\r" +
    "\n" +
    "            </ap-select-file>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"row text-danger\"  ng-if=\"selectDocumentModel.validationMessage.length > 0\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\" id=\"divValidationMessage\" name=\"divValidationMessage\">\r" +
    "\n" +
    "                {{ selectDocumentModel.validationMessage }}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/directives/apMessageAttachment.html',
    "\r" +
    "\n" +
    "<div class=\"panel\">\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-2\">\r" +
    "\n" +
    "        <ap-select-file id=\"apSelectFile\" name=\"apSelectFile\"\r" +
    "\n" +
    "                        selected-file-name=\"selectDocumentModel.selectedFileName\"\r" +
    "\n" +
    "                        selected-file-contents=\"selectDocumentModel.selectedFileContents\"\r" +
    "\n" +
    "                        selected-mime-type=\"selectDocumentModel.selectedMimeType\"\r" +
    "\n" +
    "                        validation-message=\"selectDocumentModel.validationMessage\">\r" +
    "\n" +
    "        </ap-select-file>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    " <div class=\"col-xs-10\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"attachmentList\" ng-repeat=\"attachment in attachmentDtoList\" ng-click=\"remove(attachment)\">\r" +
    "\n" +
    "          <img src=\"images/spacer.png\" class=\"attachment-svg attachment-remove\" alt=\"attachment\">\r" +
    "\n" +
    "            <div class=\"attachmentList attachmentName \"> {{ attachment.FileName | limitTo: 15 }}<span ng-if=\"attachment.FileName.length > 15\">...</span> </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row text-danger\"  ng-if=\"selectDocumentModel.validationMessage.length > 0\">\r" +
    "\n" +
    "    <div class=\"col-xs-12\" id=\"divValidationMessage\" name=\"divValidationMessage\">\r" +
    "\n" +
    "        {{ selectDocumentModel.validationMessage }}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/directives/apSelectFile.html',
    "<div>\r" +
    "\n" +
    "    <input\r" +
    "\n" +
    "        type=\"file\"\r" +
    "\n" +
    "        name=\"inputFile\"\r" +
    "\n" +
    "        id=\"inputFile\"\r" +
    "\n" +
    "        style=\"cursor:pointer; font-size:0; height:30px; width:80px; overflow:hidden; position:relative; opacity:0; -moz-opacity: 0; filter:alpha(opacity=0); z-index:3\"\r" +
    "\n" +
    "        inputfile-onchange=\"inputFileOnchangeCallback(myEventArg)\"/>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <!-- position:absolute; top:0px; width:60px; height:30px; -->\r" +
    "\n" +
    "    <div ng-if=\"!practiceForm.isPending\">\r" +
    "\n" +
    "    <button style=\"z-index:1; position:absolute; top:0px; width:80px; height:30px;\" class=\"btn btn-default1\" name=\"selectBtn\" id=\"selectBtn\">\r" +
    "\n" +
    "        <span class=\"ng-hide\" ng-show=\"sending\">\r" +
    "\n" +
    "            <ap-spinner></ap-spinner>\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "        <span ng-class=\"pull-left\" ng-hide=\"sending\">{{:: 'Upload' | translate}}</span>\r" +
    "\n" +
    "    </button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"practiceForm.isPending\">\r" +
    "\n" +
    "        <button style=\"z-index:1; position:absolute; top:0px; width:100px; height:30px;\" class=\"btn btn-default1\" name=\"selectBtn\" id=\"selectBtn\">\r" +
    "\n" +
    "            <span class=\"ng-hide\" ng-show=\"sending\">\r" +
    "\n" +
    "            <ap-spinner></ap-spinner>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "            <span class=\"ng-hide\" ng-hide=\"sending\">\r" +
    "\n" +
    "                <span class=\"pull-left lime-green\">\r" +
    "\n" +
    "                {{:: 'Form Sent' | translate}}\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/directives/apSelectImage.html',
    "<div class=\"row\" style=\"margin-top:5px; margin-bottom:5px;\">\r" +
    "\n" +
    "    <div class=\"col-xs-2\">\r" +
    "\n" +
    "        <ap-select-file\r" +
    "\n" +
    "                id=\"apSelectFile\"\r" +
    "\n" +
    "                name=\"apSelectFile\"\r" +
    "\n" +
    "                selected-file-name=\"selectImageModel.selectedFileName\"\r" +
    "\n" +
    "                selected-file-contents=\"selectImageModel.selectedFileContents\"\r" +
    "\n" +
    "                selected-mime-type=\"selectImageModel.selectedMimeType\"\r" +
    "\n" +
    "                validation-message=\"selectImageModel.validationMessage\">\r" +
    "\n" +
    "        </ap-select-file>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"col-xs-10\">\r" +
    "\n" +
    "        <input id=\"selectedImageFile\" name=\"selectedImageFile\" type=\"text\" style=\"width:100%\" ng-model=\"selectImageModel.selectedFileName\" ng-readonly=\"true\">\r" +
    "\n" +
    "        <input id=\"selectedImageMimeType\" name=\"selectedImageMimeType\" type=\"text\" style=\"width:100%\" ng-model=\"selectImageModel.selectedMimeType\" ng-readonly=\"true\">\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row\" style=\"margin-top:5px; margin-bottom:5px;\">\r" +
    "\n" +
    "    <div class=\"col-xs-2\">\r" +
    "\n" +
    "        <button style=\"width:80px;\" class=\"btn btn-default1\" name=\"selectedImageClearBtn\"  id=\"selectedImageClearBtn\" ng-click=\"clearSelectedFile()\">{{:: 'Clear' | translate }}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"col-xs-10\">\r" +
    "\n" +
    "        <span id=\"spanSelectedImage\" name=\"spanSelectedImage\" ng-if=\"selectImageModel.selectedFileName.length > 0\">\r" +
    "\n" +
    "            <img name=\"selectedImage\" id=\"selectedImage\" src=\"{{ selectImageModel.selectedFileContents }}\" style=\"height: 150px; width: 150px;\">\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row text-danger\" style=\"margin-top:5px; margin-bottom:5px;\" ng-if=\"selectImageModel.validationMessage.length > 0\">\r" +
    "\n" +
    "    <div class=\"col-xs-12\" id=\"divValidationMessage\" name=\"divValidationMessage\">\r" +
    "\n" +
    "        {{ selectImageModel.validationMessage }}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "        <ap-select-file\r" +
    "\n" +
    "                id=\"apSelectFile\"\r" +
    "\n" +
    "                name=\"apSelectFile\"\r" +
    "\n" +
    "                max-size-kb=\"selectImageModel.maxSizeKb\"\r" +
    "\n" +
    "                file-type=\"selectImageModel.fileType\"\r" +
    "\n" +
    "                selected-file-name=\"selectImageModel.selectedFileName\"\r" +
    "\n" +
    "                selected-file-contents=\"selectImageModel.selectedFileContents\"\r" +
    "\n" +
    "                selected-mime-type=\"selectImageModel.selectedMimeType\"\r" +
    "\n" +
    "                validation-message=\"selectImageModel.validationMessage\">\r" +
    "\n" +
    "        </ap-select-file>\r" +
    "\n" +
    "-->"
  );


  $templateCache.put('/app/views/landing.html',
    "<div id=\"landing-btn-group\" class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-10 col-xs-push-1\">\r" +
    "\n" +
    "        <div class=\"row tile-container\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-sm-6 col-md-3 col-lg-2 tile\">\r" +
    "\n" +
    "                <button class=\"btn btn-default btn-landing\" id=\"landing-logoff\" ng-click=\"logoff()\">\r" +
    "\n" +
    "                    <i class=\"fa fa-sign-out fa-4x\"></i>\r" +
    "\n" +
    "                    <span translate>Sign Out</span>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/login.html',
    "<div class=\"body\" ng-cloak>\r" +
    "\n" +
    "    <div id=\"login-container\" class=\"container-fluid\" ap-login-background client-Id=\"model.clientID\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-xs-flush col-md-6 col-md-offset-3\">\r" +
    "\n" +
    "                <div id=\"login-header\" class=\"logo-group\">\r" +
    "\n" +
    "                    <div class=\"row\">&nbsp;</div>\r" +
    "\n" +
    "                    <div class=\"modal-dialog modal-dialog-login\">\r" +
    "\n" +
    "                        <div class=\"row\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-xs-flush col-md-10\">\r" +
    "\n" +
    "                                <div class=\"modal-content\">\r" +
    "\n" +
    "                                    <div class=\"modal-header\">\r" +
    "\n" +
    "                                        <div class=\"text-center\">\r" +
    "\n" +
    "                                            <img src=\"images/spacer.png\" class=\"login-image\" alt=\"login-image\">\r" +
    "\n" +
    "                                            <div class=\"modal-subtitle\" id=\"myModalLabel2\" ng-if=\"model.practiceName\">\r" +
    "\n" +
    "                                                {{model.practiceName}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"modal-tagline\" id=\"myModalLabel3\" ng-if=\"model.practiceTagline\">\r" +
    "\n" +
    "                                                {{model.practiceTagline}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"modal-body\">\r" +
    "\n" +
    "                                        <form id=\"login-form\" name=\"loginForm\" ap-form-focus ng-submit=\"loginProcess()\"\r" +
    "\n" +
    "                                              novalidate>\r" +
    "\n" +
    "                                            <div ng-if=\"!selectUserMode\">\r" +
    "\n" +
    "                                                <div class=\"form-group\"\r" +
    "\n" +
    "                                                     ng-class=\"{ 'has-error' : loginForm.userName.$invalid && submitted}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <label for=\"userName\">{{::'Username' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"text\" class=\"form-control\" name=\"userName\"\r" +
    "\n" +
    "                                                           ng-model=\"model.userName\"\r" +
    "\n" +
    "                                                           placeholder=\"{{'Username' | translate}}\"\r" +
    "\n" +
    "                                                           id=\"userName\"\r" +
    "\n" +
    "                                                           ng-change=\"model.userId = null;\"\r" +
    "\n" +
    "                                                           required>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <span ng-show=\"loginForm.userName.$invalid && submitted\"\r" +
    "\n" +
    "                                                          class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <div class=\"form-group\"\r" +
    "\n" +
    "                                                     ng-class=\"{ 'has-error' : loginForm.passwordInput.$invalid && submitted}\">\r" +
    "\n" +
    "                                                    <label for=\"passwordInput\">{{::'Password' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"password\" class=\"form-control\" name=\"passwordInput\"\r" +
    "\n" +
    "                                                           ng-model=\"model.password\"\r" +
    "\n" +
    "                                                           id=\"passwordInput\"\r" +
    "\n" +
    "                                                           placeholder=\"{{'Password' | translate}}\"\r" +
    "\n" +
    "                                                           required>\r" +
    "\n" +
    "                                                    <b class=\"tooltip tooltip-top-right\">\r" +
    "\n" +
    "                                                        <i class=\"fa fa-lock txt-color-teal\"></i>\r" +
    "\n" +
    "                                                        {{::'Enter your password' | translate}}\r" +
    "\n" +
    "                                                    </b>\r" +
    "\n" +
    "                                                    <span ng-show=\"loginForm.passwordInput.$invalid && submitted\"\r" +
    "\n" +
    "                                                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <div class=\"text-center\">\r" +
    "\n" +
    "                                                    <span class=\"text-danger ng-hide\"\r" +
    "\n" +
    "                                                          ng-show=\"loginForm.passwordInput.$invalid && submitted\">\r" +
    "\n" +
    "                                                        {{::'Login could not be completed.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <div ng-show=\"errorMessage\" class=\"ng-hide\">\r" +
    "\n" +
    "                                                        <span class=\"text-danger\">\r" +
    "\n" +
    "                                                            {{errorMessage | translate}}\r" +
    "\n" +
    "                                                        </span>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                        ng-disabled=\"loading\">\r" +
    "\n" +
    "                                                    <span class=\"ng-hide\" ng-show=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                    {{'Login' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "                                                <button type=\"button\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                        id=\"settingsBtn\"\r" +
    "\n" +
    "                                                        ng-click=\"settings()\">\r" +
    "\n" +
    "                                                    {{'Settings' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </form>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                        <div class=\"text-center\">\r" +
    "\n" +
    "                                                <span>\r" +
    "\n" +
    "                                                {{::'Trouble logging in?' | translate}}\r" +
    "\n" +
    "                                                <label class=\"link clickable\" ng-click=\"forgotPassword()\">\r" +
    "\n" +
    "                                                    {{::'Reset My Password' | translate}}</label>\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <hr/>\r" +
    "\n" +
    "                                        <div class=\"row modal-content-lowercase\">\r" +
    "\n" +
    "                                            <p>{{::'Please contact our office if you need assistance.' | translate }}</p>\r" +
    "\n" +
    "                                            <div ng-if=\"assistanceInfoLoaded && !(!!loginAssistanceInfo.CustomPortalFooter)\">\r" +
    "\n" +
    "                                                <p>\r" +
    "\n" +
    "                                                    <div>{{::loginAssistanceInfo.PracticeName}}</div>\r" +
    "\n" +
    "                                                    <div>{{::loginAssistanceInfo.Address1}}</div>\r" +
    "\n" +
    "                                                    <div ng-if=\"loginAssistanceInfo.Address2\">{{::loginAssistanceInfo.Address2}}</div>\r" +
    "\n" +
    "                                                    <div>{{::loginAssistanceInfo.City}}, {{::loginAssistanceInfo.State}} {{::loginAssistanceInfo.Zip}}</div>\r" +
    "\n" +
    "                                                    <div>{{::loginAssistanceInfo.PhoneNumber}}</div>\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div ng-if=\"assistanceInfoLoaded && !!loginAssistanceInfo.CustomPortalFooter\">\r" +
    "\n" +
    "                                                <p>\r" +
    "\n" +
    "                                                    <div><pre>{{::loginAssistanceInfo.CustomPortalFooter}}</pre></div>\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <!--<div class=\"modal-footer\">-->\r" +
    "\n" +
    "                                        <!--<div class=\"text-center\">-->\r" +
    "\n" +
    "                                            <!--<p>{{::'New to our portal?' | translate}}</p>-->\r" +
    "\n" +
    "                                        <!--</div>-->\r" +
    "\n" +
    "                                        <!--<button class=\"btn btn-default1 btn-lg btn-block btn-login\"-->\r" +
    "\n" +
    "                                                <!--ng-click=\"completeAccount()\">-->\r" +
    "\n" +
    "                                            <!--{{'Create Account' | translate}}-->\r" +
    "\n" +
    "                                        <!--</button>-->\r" +
    "\n" +
    "                                    <!--</div>-->\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <!-- Below is a hack to get the android webview to behave properly while logging in.\r" +
    "\n" +
    "        If this is removed, it will cause random whitespace to appear after login.  Please don't remove. -->\r" +
    "\n" +
    "        <div class=\"row\" style=\"overflow: hidden; min-height: 1px;\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3\"\r" +
    "\n" +
    "                 style=\"margin-bottom: -99999px; padding-bottom: 99999px;\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/loginsettings.html',
    "<div class=\"body body-settings\">\r" +
    "\n" +
    "    <div class=\"container-fluid container-flush\" ng-controller=\"LoginSettingsCtrl\" ng-cloak>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3\">\r" +
    "\n" +
    "                <header class=\"text-center\">\r" +
    "\n" +
    "                    <h2>\r" +
    "\n" +
    "                        {{'Settings' | translate}}\r" +
    "\n" +
    "                    </h2>\r" +
    "\n" +
    "                </header>\r" +
    "\n" +
    "                <form name=\"settingsForm\">\r" +
    "\n" +
    "                    <div class=\"panel panel-settings-dialog\">\r" +
    "\n" +
    "                        <uib-accordion>\r" +
    "\n" +
    "                            <uib-accordion-group heading=\"Language\" is-open=\"isLanguageOpen\" template-url=\"/app/views/templates/settings-group-template.html\">\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <label>{{'Change the language:' | translate}}</label>\r" +
    "\n" +
    "                                            <select\r" +
    "\n" +
    "                                                    class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                                    ng-change=\"changeLanguage()\"\r" +
    "\n" +
    "                                                    ng-model=\"values.language\"\r" +
    "\n" +
    "                                                    ng-options=\"lang.id as lang.name for lang in languages\">\r" +
    "\n" +
    "                                            </select>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </uib-accordion-group>\r" +
    "\n" +
    "                            <uib-accordion-group heading=\"Application Information\" is-open=\"isApplicationInformationOpen\" template-url=\"/app/views/templates/settings-group-template.html\">\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <div ng-include=\"'/app/views/aboutsettings.html'\" ng-controller=\"AboutSettingsCtrl\"></div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </uib-accordion-group>\r" +
    "\n" +
    "                            <uib-accordion-group heading=\"Other\" is-open=\"isOtherOpen\" template-url=\"/app/views/templates/settings-group-template.html\" ng-show=\"showDebugSettings\">\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <label>{{'Client ID:' | translate}}</label>\r" +
    "\n" +
    "                                        <input class=\"form-control\"\r" +
    "\n" +
    "                                                ng-model=\"clientId\"\r" +
    "\n" +
    "                                                ng-change=\"changeClientId()\"\r" +
    "\n" +
    "                                                placeholder=\"{{'Client ID' | translate}}\">\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div class=\"form-group\" ng-class=\"{ 'has-error' : (settingsForm.notificationTimeout.$error.pattern)}\">\r" +
    "\n" +
    "                                        <label>{{:: 'Notification Timeout in minutes (0 - 99, where 0 is off) :' | translate}}</label>\r" +
    "\n" +
    "                                        <input class=\"form-control\"\r" +
    "\n" +
    "                                                type=\"number\"\r" +
    "\n" +
    "                                                name=\"notificationTimeout\"\r" +
    "\n" +
    "                                                ng-pattern=\"/^[0-9]{1,2}$/\"\r" +
    "\n" +
    "                                                ng-model=\"notificationTimeout\"\r" +
    "\n" +
    "                                                ng-change=\"changeNotificationTimeout()\"\r" +
    "\n" +
    "                                                placeholder=\"{{:: 'Notification Timeout' | translate}}\">\r" +
    "\n" +
    "                                        <div class=\"ap-settings-invalid-timeout\" ng-show=\"settingsForm.notificationTimeout.$error.pattern\">\r" +
    "\n" +
    "                                            {{:: 'Timeout must be a number between 0 and 99.' | translate }}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </uib-accordion-group>\r" +
    "\n" +
    "                        </uib-accordion>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <footer>\r" +
    "\n" +
    "                        <span ng-show=\"(actionMessage === 'reset')\" translate>Client ID Successfully Reset.</span>\r" +
    "\n" +
    "                        <span ng-show=\"(actionMessage === 'failed')\" translate>Failed, please try again.</span>\r" +
    "\n" +
    "                        <span ng-show=\"(actionMessage === 'english')\" translate>Language Set to English.</span>\r" +
    "\n" +
    "                        <span ng-show=\"(actionMessage === 'spanish')\" translate>Language Set to Spanish.</span>\r" +
    "\n" +
    "                        <button class=\"btn btn-primary btn-block\"\r" +
    "\n" +
    "                                id=\"backToLoginBtn\"\r" +
    "\n" +
    "                                ng-click=\"backButton()\">\r" +
    "\n" +
    "                            {{'Back to Login' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <button id=\"clearStorageBtn\"\r" +
    "\n" +
    "                                class=\"btn btn-default btn-block\"\r" +
    "\n" +
    "                                ng-click=\"clearClientId()\"\r" +
    "\n" +
    "                                ng-show=\"showDebugSettings\">\r" +
    "\n" +
    "                            {{'Reset Client ID' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </footer>\r" +
    "\n" +
    "                </form>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/mfa-login.html',
    "<div class=\"body\" ng-cloak>\r" +
    "\n" +
    "    <div id=\"login-container\" class=\"container-fluid ng-hide\" ap-login-background client-Id=\"model.clientID\" ng-show=\"splash\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-xs-flush col-md-6 col-md-offset-3\">\r" +
    "\n" +
    "                <div id=\"login-header\" class=\"logo-group\">\r" +
    "\n" +
    "                    <div class=\"row\">&nbsp;</div>\r" +
    "\n" +
    "                    <div class=\"modal-dialog modal-dialog-login\">\r" +
    "\n" +
    "                        <div class=\"row\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-xs-flush col-md-10\">\r" +
    "\n" +
    "                                <div class=\"modal-content\">\r" +
    "\n" +
    "                                    <div class=\"modal-header\">\r" +
    "\n" +
    "                                        <div class=\"text-center\">\r" +
    "\n" +
    "                                            <img src=\"images/spacer.png\" class=\"login-image\" alt=\"login-image\">\r" +
    "\n" +
    "                                            <div class=\"modal-subtitle\" id=\"myModalLabel2\" ng-if=\"practiceModel.practiceName\">\r" +
    "\n" +
    "                                                {{practiceModel.practiceName}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"modal-tagline\" id=\"myModalLabel3\" ng-if=\"practiceModel.practiceTagline\">\r" +
    "\n" +
    "                                                {{practiceModel.practiceTagline}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"modal-body\">\r" +
    "\n" +
    "                                        <div class=\"description-text\">\r" +
    "\n" +
    "                                            <p ng-show=\"errorMessage\" class=\"text-danger ng-hide\"><span>{{errorMessage | translate}}</span></p>\r" +
    "\n" +
    "                                            <p ng-show=\"registrationIssue\" class=\"ng-hide\"><b><span>{{registrationIssue | translate}}</span></b></p>\r" +
    "\n" +
    "                                            <p ng-show=\"mfaNextSteps\" class=\"ng-hide\"><span><b>{{mfaNextSteps | translate}} Use this to continue your multi-factor credential setup.  After you finish the registration steps, you may continue to login here.</b></span></p>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div ng-show=\"mfaRouter\">\r" +
    "\n" +
    "                                            <form id=\"route-username-form\" name=\"routeUsernameForm\" ap-form-focus ng-submit=\"routeUsername()\" novalidate>\r" +
    "\n" +
    "                                                <div class=\"form-group\" ng-class=\"{ 'has-error' : routeUsernameForm.userName.$invalid && submitted}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <label for=\"userName\">{{::'Username' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"text\" class=\"form-control\" name=\"userName\"\r" +
    "\n" +
    "                                                        ng-model=\"routerModel.userName\"\r" +
    "\n" +
    "                                                        placeholder=\"{{'Username' | translate}}\"\r" +
    "\n" +
    "                                                        id=\"userName\"\r" +
    "\n" +
    "                                                        required>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <span ng-show=\"routeUsernameForm.userName.$invalid && submitted\"\r" +
    "\n" +
    "                                                        class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\">\r" +
    "\n" +
    "                                                        <span class=\"ng-hide\" ng-show=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                        {{'Submit' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </form>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div ng-show=\"mfaRegister\">\r" +
    "\n" +
    "                                            <div class=\"description-box\">\r" +
    "\n" +
    "                                                <p><b>For your account’s continued security, CGM Aprima Patient Portal now requires multi-factor authentication for account access.</b></p>\r" +
    "\n" +
    "                                                <p>To access your account, you must first complete the CGM Identity account registration and then setup and enable two-factor authentication with an Authenticator app on your smartphone.</p>\r" +
    "\n" +
    "                                                <p>After entering your username, and then your passcode, we will walk you through the steps for setup. Once you have completed these steps, you will be redirected to a different login page, after you enter your username, using the new, more secure process.</p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <form id=\"register-form\" name=\"registerForm\" ap-form-focus ng-submit=\"register()\" novalidate>\r" +
    "\n" +
    "                                                <input type=\"hidden\" class=\"form-control\" name=\"userName\"\r" +
    "\n" +
    "                                                        ng-model=\"registerModel.userName\"\r" +
    "\n" +
    "                                                        id=\"userName\"\r" +
    "\n" +
    "                                                        >\r" +
    "\n" +
    "                                                <div class=\"form-group\"\r" +
    "\n" +
    "                                                        ng-class=\"{ 'has-error' : registerForm.passwordInput.$invalid && submitted}\">\r" +
    "\n" +
    "                                                        <label for=\"passwordInput\">{{::'Password' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                        <input type=\"password\" class=\"form-control\" name=\"passwordInput\"\r" +
    "\n" +
    "                                                            ng-model=\"registerModel.password\"\r" +
    "\n" +
    "                                                            id=\"passwordInput\"\r" +
    "\n" +
    "                                                            placeholder=\"{{'Password' | translate}}\"\r" +
    "\n" +
    "                                                            required>\r" +
    "\n" +
    "                                                        <b class=\"tooltip tooltip-top-right\">\r" +
    "\n" +
    "                                                            <i class=\"fa fa-lock txt-color-teal\"></i>\r" +
    "\n" +
    "                                                            {{::'Enter your password' | translate}}\r" +
    "\n" +
    "                                                        </b>\r" +
    "\n" +
    "                                                        <span ng-show=\"registerForm.passwordInput.$invalid && submitted\"\r" +
    "\n" +
    "                                                            class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                            {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                        </span>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\">\r" +
    "\n" +
    "                                                        <span class=\"ng-hide\" ng-show=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                        {{'Submit' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                    <button type=\"button\" class=\"btn btn-secondary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\" ng-click=\"cancel()\">\r" +
    "\n" +
    "                                                        {{'Cancel' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </form>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div ng-show=\"mfaLogin\">\r" +
    "\n" +
    "                                            <form id=\"login-form\" name=\"loginForm\" ap-form-focus ng-submit=\"login()\" novalidate>\r" +
    "\n" +
    "                                                <input type=\"hidden\" class=\"form-control\" name=\"userName\"\r" +
    "\n" +
    "                                                        ng-model=\"loginModel.userName\"\r" +
    "\n" +
    "                                                        id=\"userName\"\r" +
    "\n" +
    "                                                        >\r" +
    "\n" +
    "                                                <div class=\"form-group\"\r" +
    "\n" +
    "                                                        ng-class=\"{ 'has-error' : loginForm.passwordInput.$invalid && submitted}\">\r" +
    "\n" +
    "                                                        <label for=\"passwordInput\">{{::'Password' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                        <input type=\"password\" class=\"form-control\" name=\"passwordInput\"\r" +
    "\n" +
    "                                                            ng-model=\"loginModel.password\"\r" +
    "\n" +
    "                                                            id=\"passwordInput\"\r" +
    "\n" +
    "                                                            placeholder=\"{{'Password' | translate}}\"\r" +
    "\n" +
    "                                                            required>\r" +
    "\n" +
    "                                                        <b class=\"tooltip tooltip-top-right\">\r" +
    "\n" +
    "                                                            <i class=\"fa fa-lock txt-color-teal\"></i>\r" +
    "\n" +
    "                                                            {{::'Enter your password' | translate}}\r" +
    "\n" +
    "                                                        </b>\r" +
    "\n" +
    "                                                        <span ng-show=\"loginForm.passwordInput.$invalid && submitted\"\r" +
    "\n" +
    "                                                            class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                            {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                        </span>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\">\r" +
    "\n" +
    "                                                        <span class=\"ng-hide\" ng-show=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                        {{'Submit' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                    <button type=\"button\" class=\"btn btn-secondary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\" ng-click=\"cancel()\">\r" +
    "\n" +
    "                                                        {{'Cancel' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </form>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div ng-show=\"mfaConfirm\">\r" +
    "\n" +
    "                                            <div class=\"description-box\">\r" +
    "\n" +
    "                                                <p>Our security policies require both an email address, and a date of birth, on record for you to register a multi-factor account.</p>\r" +
    "\n" +
    "                                                <p>Please verify that this data is correct, or enter.  <b>Note: Your email address will be your new username.</b></p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <form id=\"confirmation-form\" name=\"confirmationForm\" ap-form-focus ng-submit=\"confirm()\" novalidate>\r" +
    "\n" +
    "                                                <input type=\"hidden\" class=\"form-control\" name=\"personId\"\r" +
    "\n" +
    "                                                        ng-model=\"confirmModel.personId\"\r" +
    "\n" +
    "                                                        id=\"personId\"\r" +
    "\n" +
    "                                                       >\r" +
    "\n" +
    "                                                <div class=\"form-group\" ng-class=\"{ 'has-error' : confirmationForm.dateOfBirth.$invalid && submitted}\">\r" +
    "\n" +
    "                                                    <label for=\"dateOfBirth\">{{::'Date Of Birth' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"date\" class=\"form-control\" name=\"dateOfBirth\"\r" +
    "\n" +
    "                                                        ng-model=\"confirmModel.dateOfBirth\"\r" +
    "\n" +
    "                                                        placeholder=\"{{'Date Of Birth' | translate}}\"\r" +
    "\n" +
    "                                                        id=\"dateOfBirth\"\r" +
    "\n" +
    "                                                        required>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <span ng-show=\"confirmationForm.dateOfBirth.$invalid && submitted\"\r" +
    "\n" +
    "                                                        class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div class=\"form-group\" ng-class=\"{ 'has-error' : confirmationForm.emailAddress.$invalid && submitted}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <label for=\"emailAddress\">{{::'Email Address' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"text\" class=\"form-control\" name=\"emailAddress\"\r" +
    "\n" +
    "                                                        ng-model=\"confirmModel.emailAddress\"\r" +
    "\n" +
    "                                                        placeholder=\"{{'Email Address' | translate}}\"\r" +
    "\n" +
    "                                                        id=\"emailAddress\"\r" +
    "\n" +
    "                                                        required>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <span ng-show=\"confirmationForm.emailAddress.$invalid && submitted\"\r" +
    "\n" +
    "                                                        class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>\r" +
    "\n" +
    "                                                    <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\">\r" +
    "\n" +
    "                                                        <span class=\"ng-hide\" ng-show=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                        {{'Submit' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                    <button type=\"button\" class=\"btn btn-secondary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                            ng-disabled=\"loading\" ng-click=\"cancel()\">\r" +
    "\n" +
    "                                                        {{'Cancel' | translate}}\r" +
    "\n" +
    "                                                    </button>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </form>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <br>\r" +
    "\n" +
    "                                        <div class=\"row modal-content-lowercase\">\r" +
    "\n" +
    "                                            <hr/>\r" +
    "\n" +
    "                                            \r" +
    "\n" +
    "                                            <div ng-if=\"assistanceInfoLoaded\">\r" +
    "\n" +
    "                                                <div ng-show=\"loginAssistanceInfo.CustomPortalFooter\">\r" +
    "\n" +
    "                                                    <p>\r" +
    "\n" +
    "                                                        <div ng-bind-html=\"loginAssistanceInfo.CustomPortalFooter\"></div>\r" +
    "\n" +
    "                                                    </p>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div ng-hide=\"loginAssistanceInfo.CustomPortalFooter\">\r" +
    "\n" +
    "                                                    <p>\r" +
    "\n" +
    "                                                        <p>{{::'Please contact our office if you need assistance.' | translate }}</p>\r" +
    "\n" +
    "                                                        <div>{{::loginAssistanceInfo.PracticeName}}</div>\r" +
    "\n" +
    "                                                        <div>{{::loginAssistanceInfo.Address1}}</div>\r" +
    "\n" +
    "                                                        <div ng-if=\"loginAssistanceInfo.Address2\">{{::loginAssistanceInfo.Address2}}</div>\r" +
    "\n" +
    "                                                        <div>{{::loginAssistanceInfo.City}}, {{::loginAssistanceInfo.State}} {{::loginAssistanceInfo.Zip}}</div>\r" +
    "\n" +
    "                                                        <div>{{::loginAssistanceInfo.PhoneNumber}}</div>\r" +
    "\n" +
    "                                                    </p>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <!-- Below is a hack to get the android webview to behave properly while logging in.\r" +
    "\n" +
    "        If this is removed, it will cause random whitespace to appear after login.  Please don't remove. -->\r" +
    "\n" +
    "        <div class=\"row\" style=\"overflow: hidden; min-height: 1px;\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3\"\r" +
    "\n" +
    "                 style=\"margin-bottom: -99999px; padding-bottom: 99999px;\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/modals/apidocumentationgatekeepermodal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'API Documentation Disclaimer' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <p>As a patient, you have the right to access information in your health record via an app of your choice, \r" +
    "\n" +
    "                provided it meets the technical specifications required by law.\r" +
    "\n" +
    "                Examples of apps you may use include Health (Apple), CommonHealth (Android), or iBlueButton (Medicare and Veterans). \r" +
    "\n" +
    "                While not required, you may want to check the security and privacy standards of your app to ensure that your health \r" +
    "\n" +
    "                information will be protected and secure. A connection can be made from your provider’s database to the app of your \r" +
    "\n" +
    "                choice using the information provided here. Please contact the office for further details.</p>        \r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'Error loading privacy policy.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'Error loading privacy policy.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "            <button id=\"agreeBtn\" type=\"submit\" class=\"btn btn-primary btn-lg btn-block\" ng-click=\"ok()\">\r" +
    "\n" +
    "                <i class=\"fa fa-4x\"></i>\r" +
    "\n" +
    "                {{::'Agree' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "            <button id=\"disagreeBtn\" type=\"button\" class=\"btn btn-default2 btn-lg btn-block\" ng-click=\"cancel()\">\r" +
    "\n" +
    "                <i class=\"fa fa-4x\"></i>\r" +
    "\n" +
    "                {{::'Cancel' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/modals/practicetermsmodal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'Patient Portal Practice Terms' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <p ng-if=\"practiceConsent\"  ng-bind-html=\"practiceConsent\">\r" +
    "\n" +
    "            </p>\r" +
    "\n" +
    "            <p ng-if=\"!practiceConsent\">\r" +
    "\n" +
    "                {{'You must login to view terms' | translate}}\r" +
    "\n" +
    "            </p>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'Error loading practice terms.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'Error loading practice terms.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/modals/privacypolicymodal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'Patient Portal Privacy Policy' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div ng-if=\"privacyPolicyUrl\">\r" +
    "\n" +
    "                <iframe ng-src=\"{{::privacyPolicyUrl}}\"></iframe>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"!privacyPolicyUrl\">\r" +
    "\n" +
    "                {{'You must login to view policy.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'Error loading privacy policy.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'Error loading privacy policy.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/navigation/navigationDoctors.html',
    "<div class=\"panel panel-dashboard\">\r" +
    "\n" +
    "    <img class=\"page-image doctors\">\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<!--<div ng-cloak>-->\r" +
    "\n" +
    "    <!--<div id=\"doctors-panel\" class=\"panel panel-default panel-flush\">-->\r" +
    "\n" +
    "        <!--<div class=\"panel-heading\">-->\r" +
    "\n" +
    "            <!--{{::'Doctors' | translate}} - {{CurrentUser.FullName}}-->\r" +
    "\n" +
    "        <!--</div>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <!--<div ng-if=\"!loading && !httpError\" class=\"panel-body\">-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <!--<div class=\"form-section\">-->\r" +
    "\n" +
    "                <!--<h3>Doctors</h3>-->\r" +
    "\n" +
    "                <!--<h3>...Coming Soon...</h3>-->\r" +
    "\n" +
    "                <!--<h4><a id=\"landing-btn\" data-transition-to=\"{appRoute: 'landing'}\"><strong>Landing Page</strong></a></h4>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <!--</div>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <!--</div>-->\r" +
    "\n" +
    "        <!--<div ng-if=\"loading || httpError\">-->\r" +
    "\n" +
    "            <!--<div class=\"text-center\" ng-show=\"loading\">-->\r" +
    "\n" +
    "                <!--<span><i class=\"fa fa-spinner fa-spin fa-3x\"></i></span>-->\r" +
    "\n" +
    "            <!--</div>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <!--<uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>-->\r" +
    "\n" +
    "                <!--{{::\"An error has occurred and the patient info could not be loaded.\" | translate}}-->\r" +
    "\n" +
    "            <!--</uib-alert>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <!--<uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>-->\r" +
    "\n" +
    "                <!--You do not have access to this patient's info.-->\r" +
    "\n" +
    "            <!--</uib-alert>-->\r" +
    "\n" +
    "        <!--</div>-->\r" +
    "\n" +
    "    <!--</div>-->\r" +
    "\n" +
    "<!--</div>-->"
  );


  $templateCache.put('/app/views/settings-phone.html',
    "<div class=\"body-inverse ng-hide\" ng-show=\"true\">\r" +
    "\n" +
    "    <div class=\"container-fluid container-flush\" id=\"settings\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel-group\" id=\"accordian\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel panel-ap-settings\" id=\"appointments-settings-option\">\r" +
    "\n" +
    "                <div class=\"panel-heading\" data-toggle=\"collapse\" ng-click=\"switch('appointments');\"\r" +
    "\n" +
    "                     data-parent=\"#accordian\" href=\"#appointments\">\r" +
    "\n" +
    "                    <div class=\"panel-title\" ng-class=\"options.selectedGroup === 'appointments' ? 'selected' : 'deselected'\">\r" +
    "\n" +
    "                        {{'Schedule Settings' | translate}}\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-md-1 pull-right\">\r" +
    "\n" +
    "                            <span ng-class=\"options.selectedGroup === 'appointments'? 'ap-chevron-up':'ap-chevron-down'\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"panel-collapse collapse\" id=\"appointments\">\r" +
    "\n" +
    "                    <div class=\"panel-body \">\r" +
    "\n" +
    "                        <div ng-include=\"'/app/views/appointmentlistsettings.html'\"\r" +
    "\n" +
    "                             ng-controller=\"AppointmentListSettingsCtrl\"></div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel panel-ap-settings\" id=\"messages-settings-option\">\r" +
    "\n" +
    "                <div class=\"panel-heading\" data-toggle=\"collapse\" ng-click=\"switch('messages');\"\r" +
    "\n" +
    "                     data-parent=\"#accordian\" href=\"#messages\">\r" +
    "\n" +
    "                    <div class=\"panel-title\" ng-class=\"options.selectedGroup === 'messages' ? 'selected' : 'deselected'\">\r" +
    "\n" +
    "                        {{'Messages Settings' | translate}}\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-md-1 pull-right\">\r" +
    "\n" +
    "                            <span ng-class=\"options.selectedGroup === 'messages'? 'ap-chevron-up':'ap-chevron-down'\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"panel-collapse collapse\" id=\"messages\">\r" +
    "\n" +
    "                    <div class=\"panel-body \">\r" +
    "\n" +
    "                        <div ng-include=\"'/app/views/messagelistsettings.html'\"\r" +
    "\n" +
    "                             ng-controller=\"MessageListSettingsCtrl\"></div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel panel-ap-settings\" id=\"user-settings-option\">\r" +
    "\n" +
    "                <div class=\"panel-heading\" data-toggle=\"collapse\" ng-click=\"switch('user');\"\r" +
    "\n" +
    "                     data-parent=\"#accordian\" href=\"#user\">\r" +
    "\n" +
    "                    <div class=\"panel-title\" ng-class=\"options.selectedGroup === 'user' ? 'selected' : 'deselected'\">\r" +
    "\n" +
    "                        {{'User Settings' | translate}}\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-md-1 pull-right\">\r" +
    "\n" +
    "                            <span ng-class=\"options.selectedGroup === 'user'? 'ap-chevron-up':'ap-chevron-down'\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div id=\"user\" class=\"panel-collapse collapse\">\r" +
    "\n" +
    "                    <div class=\"panel-body\">\r" +
    "\n" +
    "                        <div ng-include=\"'/app/views/usersettings.html'\" ng-controller=\"UserSettingsCtrl\"></div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel panel-ap-settings\" id=\"about-settings-option\">\r" +
    "\n" +
    "                <div class=\"panel-heading\" data-toggle=\"collapse\" ng-click=\"switch('about');\"\r" +
    "\n" +
    "                     data-parent=\"#accordian\" href=\"#about\">\r" +
    "\n" +
    "                    <div class=\"panel-title\" ng-class=\"options.selectedGroup === 'about' ? 'selected' : 'deselected'\">\r" +
    "\n" +
    "                        {{'About' | translate}}\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-md-1 pull-right\">\r" +
    "\n" +
    "                            <span ng-class=\"options.selectedGroup === 'about'? 'ap-chevron-up':'ap-chevron-down'\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"panel-collapse collapse\" id=\"about\">\r" +
    "\n" +
    "                    <div class=\"panel-body \">\r" +
    "\n" +
    "                        <div ng-include=\"'/app/views/aboutsettings.html'\" ng-controller=\"AboutSettingsCtrl\"></div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel panel-ap-settings\" id=\"logoff-setting\">\r" +
    "\n" +
    "                <div class=\"panel-heading\">\r" +
    "\n" +
    "                    <div class=\"panel-title deselected\"\r" +
    "\n" +
    "                         ng-click=\"logoff();\">\r" +
    "\n" +
    "                        {{'Log off' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/settings-tablet.html',
    "<div class=\"body-inverse ng-hide\" ng-cloak ng-show=\"true\">\r" +
    "\n" +
    "    <div id=\"settings\" class=\"container-fluid container-flush\" ng-controller=\"LoginSettingsCtrl\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-sm-6 col-xs-flush\">\r" +
    "\n" +
    "                <ul class=\"list-group list-group-menu blur-deselected list-group-flush-left list-group-flush-top\">\r" +
    "\n" +
    "                    <li id=\"appointments-settings-option\"\r" +
    "\n" +
    "                        class=\"list-group-item\"\r" +
    "\n" +
    "                        ng-click=\"options.selectedGroup = 'appointmentslist'\"\r" +
    "\n" +
    "                        ng-class=\"{'selected' : options.selectedGroup === 'appointmentslist', 'deselected' : options.selectedGroup !== 'appointmentslist'}\">\r" +
    "\n" +
    "                        <div class=\"pull-right\">\r" +
    "\n" +
    "                            <span class=\"ap-chevron-right-lt-gray\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <span class=\"header\">{{\"Schedule Settings\" | translate}}</span>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                    <li id=\"messages-settings-option\"\r" +
    "\n" +
    "                        class=\"list-group-item\"\r" +
    "\n" +
    "                        ng-click=\"options.selectedGroup = 'messageslist'\"\r" +
    "\n" +
    "                        ng-class=\"{'selected' : options.selectedGroup === 'messageslist', 'deselected' : options.selectedGroup !== 'messageslist'}\">\r" +
    "\n" +
    "                        <div class=\"pull-right\">\r" +
    "\n" +
    "                            <span class=\"ap-chevron-right-lt-gray\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <span class=\"header\">{{\"Messages Settings\" | translate}}</span>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                    <li id=\"user-settings-option\"\r" +
    "\n" +
    "                        class=\"list-group-item\"\r" +
    "\n" +
    "                        ng-click=\"options.selectedGroup = 'user'\"\r" +
    "\n" +
    "                        ng-class=\"{'selected' : options.selectedGroup === 'user', 'deselected' : options.selectedGroup !== 'user'}\">\r" +
    "\n" +
    "                        <div class=\"pull-right\">\r" +
    "\n" +
    "                            <span class=\"ap-chevron-right-lt-gray\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <span class=\"header\">{{\"User Settings\" | translate}}</span>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                    <li id=\"about-settings-option\"\r" +
    "\n" +
    "                        class=\"list-group-item\"\r" +
    "\n" +
    "                        ng-click=\"options.selectedGroup = 'about'\"\r" +
    "\n" +
    "                        ng-class=\"{'selected' : options.selectedGroup === 'about', 'deselected' : options.selectedGroup !== 'about'}\">\r" +
    "\n" +
    "                        <div class=\"pull-right\">\r" +
    "\n" +
    "                            <span class=\"ap-chevron-right-lt-gray\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <span class=\"header\">{{\"About\" | translate}}</span>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <li id=\"logoff-setting\" class=\"list-group-item deselected\" ng-click=\"logoff()\">\r" +
    "\n" +
    "                        <span class=\"header\">{{\"Log off\" | translate}}</span>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-sm-6 col-flush\" ng-switch=\"options.selectedGroup\">\r" +
    "\n" +
    "                <div ng-switch-when=\"dashboard\">\r" +
    "\n" +
    "                    <div ng-include=\"'/app/views/dashboardsettings.html'\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-switch-when=\"appointmentslist\">\r" +
    "\n" +
    "                    <div ng-include=\"'/app/views/appointmentlistsettings.html'\"\r" +
    "\n" +
    "                         ng-controller=\"AppointmentListSettingsCtrl\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-switch-when=\"messageslist\">\r" +
    "\n" +
    "                    <div ng-include=\"'/app/views/messagelistsettings.html'\" ng-controller=\"MessageListSettingsCtrl\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-switch-when=\"user\">\r" +
    "\n" +
    "                    <div ng-include=\"'/app/views/usersettings.html'\" ng-controller=\"UserSettingsCtrl\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-switch-when=\"about\">\r" +
    "\n" +
    "                    <div ng-include=\"'/app/views/aboutsettings.html'\" ng-controller=\"AboutSettingsCtrl\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/statementslogin.html',
    "\r" +
    "\n" +
    "    <div class=\"body\" ng-cloak>\r" +
    "\n" +
    "            <div id=\"login-container\" class=\"container-fluid\" ap-login-background client-Id=\"model.clientID\">\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-md-6 col-md-offset-3\">\r" +
    "\n" +
    "                        <div id=\"login-header\" class=\"logo-group\">\r" +
    "\n" +
    "                            <div class=\"row\">&nbsp;</div>\r" +
    "\n" +
    "                            <div class=\"modal-dialog modal-dialog-login\">\r" +
    "\n" +
    "                                <div class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-xs-flush col-md-10\">\r" +
    "\n" +
    "                                        <div class=\"modal-content\">\r" +
    "\n" +
    "                                            <div class=\"modal-header\">\r" +
    "\n" +
    "                                                <div class=\"text-center\">\r" +
    "\n" +
    "                                                    <img src=\"images/spacer.png\" class=\"login-image\" alt=\"login-image\">\r" +
    "\n" +
    "                                                    <div class=\"modal-subtitle\" id=\"myModalLabel2\" ng-if=\"model.practiceName\">\r" +
    "\n" +
    "                                                        {{model.practiceName}}\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <div class=\"modal-tagline\" id=\"myModalLabel3\" ng-if=\"model.practiceTagline\">\r" +
    "\n" +
    "                                                        {{model.practiceTagline}}\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <h1 class=\"large-description text-center\">View And Pay Statements</h1>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"modal-body\">\r" +
    "\n" +
    "                                                <form id=\"login-form\" name=\"loginForm\" ap-form-focus ng-submit=\"loginProcess()\"\r" +
    "\n" +
    "                                                      novalidate>\r" +
    "\n" +
    "                                                    <div class=\"form-group\"\r" +
    "\n" +
    "                                                    ng-class=\"{ 'has-error' : loginForm.accessCode.$invalid && submitted}\">\r" +
    "\n" +
    "                                                        <label for=\"zipCode\">{{::'Access Code' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                        <input class=\"form-control\" name=\"accessCode\"\r" +
    "\n" +
    "                                                                ng-model=\"model.accessCode\"\r" +
    "\n" +
    "                                                                id=\"accessCode\"\r" +
    "\n" +
    "                                                                placeholder=\"{{'ER879B3' | translate}}\"\r" +
    "\n" +
    "                                                                required>\r" +
    "\n" +
    "                                                        <span ng-show=\"loginForm.accessCode.$invalid && submitted\"\r" +
    "\n" +
    "                                                            class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                            {{::'Not valid format.' | translate}}<br/>\r" +
    "\n" +
    "                                                            {{::'12345' | translate}}\r" +
    "\n" +
    "                                                        </span>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <div class=\"form-group\"\r" +
    "\n" +
    "                                                             ng-class=\"{ 'has-error' : loginForm.zipCode.$invalid && submitted}\">\r" +
    "\n" +
    "                                                            <label for=\"zipCode\">{{::'ZipCode' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                            <input class=\"form-control\" name=\"zipCode\"\r" +
    "\n" +
    "                                                                   ng-model=\"model.zipCode\"\r" +
    "\n" +
    "                                                                   id=\"zipCode\"\r" +
    "\n" +
    "                                                                   placeholder=\"{{'12345' | translate}}\"\r" +
    "\n" +
    "                                                                   ng-pattern=\"zipCodeRegex\"\r" +
    "\n" +
    "                                                                   required>\r" +
    "\n" +
    "                                                            <span ng-show=\"loginForm.zipCode.$invalid && submitted\"\r" +
    "\n" +
    "                                                                  class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                                {{::'Not valid format.' | translate}}<br/>\r" +
    "\n" +
    "                                                                {{::'12345' | translate}}\r" +
    "\n" +
    "                                                            </span>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                   <div class=\"modal-text\">\r" +
    "\n" +
    "                                                       {{::'Provide one of the following:' | translate}}\r" +
    "\n" +
    "                                                   </div>\r" +
    "\n" +
    "                                                    <div ng-if=\"!selectUserMode\">\r" +
    "\n" +
    "                                                        <div class=\"form-group\"\r" +
    "\n" +
    "                                                             ng-class=\"{ 'has-error' : loginForm.birthDate.$invalid && submitted}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                         <label for=\"birthDate\">{{::'BirthDate' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                            <input type=\"text\" class=\"form-control\" name=\"birthDate\"\r" +
    "\n" +
    "                                                                   ng-model=\"model.birthDate\"\r" +
    "\n" +
    "                                                                   placeholder=\"{{'yyyy-mm-dd' | translate}}\"\r" +
    "\n" +
    "                                                                   id=\"birthDate\"\r" +
    "\n" +
    "                                                                   ng-pattern=\"birthDateRegex\"\r" +
    "\n" +
    "                                                                   ng-required=\"!model.phoneNumber\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                          <span ng-show=\"loginForm.birthDate.$invalid && submitted\"\r" +
    "\n" +
    "                                                                  class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid format.' | translate}}<br/>\r" +
    "\n" +
    "                                                        {{::'yyyy-mm-dd' | translate}}\r" +
    "\n" +
    "                                                     </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                        </div>\r" +
    "\n" +
    "                                                        <div class=\"form-group\"\r" +
    "\n" +
    "                                                             ng-class=\"{ 'has-error' : loginForm.phoneNumber.$invalid && submitted}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                         <label for=\"phoneNumber\">{{::'Phone Number' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                            \r" +
    "\n" +
    "                                                         <input class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" ng-model=\"model.phoneNumber\" type=\"text\"\r" +
    "\n" +
    "                                                         placeholder=\"(XXX)XXX-XXXX\" ng-pattern=\"phoneRegEx\" ng-required=\"!model.birthDate\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                          <span ng-show=\"loginForm.phoneNumber.$invalid && submitted\"\r" +
    "\n" +
    "                                                                  class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                            {{::'Not valid format.' | translate}}<br/>\r" +
    "\n" +
    "                                                            {{::'(XXX)XXX-XXXX' | translate}}\r" +
    "\n" +
    "                                                        </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                        </div>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <div class=\"text-center\">\r" +
    "\n" +
    "                                                        <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                                            <div class=\"row\">\r" +
    "\n" +
    "                                                                <div ng-show=\"errorMessage\" class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                                    <div class=\"pre\">{{errorMessage | translate}} </div>\r" +
    "\n" +
    "                                                                </div>\r" +
    "\n" +
    "                                                            </div>\r" +
    "\n" +
    "                                                        </div>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <div>\r" +
    "\n" +
    "                                                        <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                                ng-disabled=\"loading\">\r" +
    "\n" +
    "                                                            <span class=\"ng-hide\" ng-show=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                            {{'Login' | translate}}\r" +
    "\n" +
    "                                                        </button>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                </form>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                           </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <!-- Below is a hack to get the android webview to behave properly while logging in.\r" +
    "\n" +
    "                If this is removed, it will cause random whitespace to appear after login.  Please don't remove. -->\r" +
    "\n" +
    "                <div class=\"row\" style=\"overflow: hidden; min-height: 1px;\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3\"\r" +
    "\n" +
    "                         style=\"margin-bottom: -99999px; padding-bottom: 99999px;\"></div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/templates/settings-group-template.html',
    "<div class=\"panel panel-ap-portal-settings\">\r" +
    "\n" +
    "    <div class=\"panel-heading clickable\" data-toggle=\"collapse\" ng-click=\"toggleOpen()\">\r" +
    "\n" +
    "        <div class=\"panel-title\" ng-class=\"isOpen ? 'selected' : 'deselected'\">\r" +
    "\n" +
    "            {{heading | translate}}\r" +
    "\n" +
    "            <div class=\"col-xs-1 col-md-1 pull-right\">\r" +
    "\n" +
    "                <span ng-class=\"isOpen ? 'ap-chevron-up-gray' : 'ap-chevron-down-gray'\"></span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\r" +
    "\n" +
    "        <div class=\"panel-body\" ng-transclude>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/usersettings.html',
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-12\">\r" +
    "\n" +
    "        <div id=\"user-settings\" class=\"form-section\" ng-cloak>\r" +
    "\n" +
    "            <div class=\"form-section-header\">\r" +
    "\n" +
    "                {{::'User Settings' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label>{{::'Logged in as' | translate}}</label>\r" +
    "\n" +
    "                <div class=\"form-control-static\">\r" +
    "\n" +
    "                    {{::usersettings.username}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label>{{::'Client ID' | translate}}</label>\r" +
    "\n" +
    "                <div class=\"form-control-static\">\r" +
    "\n" +
    "                    {{::usersettings.clientId}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label for=\"language-input\">{{::'Change the language:' | translate}}</label>\r" +
    "\n" +
    "                    <select id=\"language-input\"\r" +
    "\n" +
    "                            class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                            ng-change=\"changeLanguage()\"\r" +
    "\n" +
    "                            ng-model=\"usersettings.language\"\r" +
    "\n" +
    "                            ng-options=\"language.id as language.name for language in usersettings.languages\">\r" +
    "\n" +
    "                    </select>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/viewApiDocumentModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{model.Title}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <ap-document-viewer-with-download\r" +
    "\n" +
    "            disable-inline-pdf=\"model.DisableInlinePdf\"\r" +
    "\n" +
    "            document-helper=\"model.DocumentHelper\"\r" +
    "\n" +
    "            document-id=\"model.DocumentId\"\r" +
    "\n" +
    "            download-file-name=\"model.DownloadFileName\"\r" +
    "\n" +
    "            enable-download=\"model.EnableDownload\"\r" +
    "\n" +
    "            has-static-url=\"model.HasStaticUrl\"\r" +
    "\n" +
    "            document-download=\"downloadDocument(documentId)\"\r" +
    "\n" +
    "            document-get-static-url=\"getStaticUrl(documentId)\"\r" +
    "\n" +
    "            document-load=\"loadDocument(documentId, requestSettings)\"\r" +
    "\n" +
    "        ></ap-document-viewer-with-download>\r" +
    "\n" +
    "        <p><span class=\"text-bold\">Client ID:</span> {{:: model.ClientID }}<br />\r" +
    "\n" +
    "        <span class=\"text-bold\">Base URL:</span> {{:: model.ClientURL }}</p>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/viewDocumentModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{model.Title}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <ap-document-viewer-with-download\r" +
    "\n" +
    "            disable-inline-pdf=\"model.DisableInlinePdf\"\r" +
    "\n" +
    "            document-helper=\"model.DocumentHelper\"\r" +
    "\n" +
    "            document-id=\"model.DocumentId\"\r" +
    "\n" +
    "            download-file-name=\"model.DownloadFileName\"\r" +
    "\n" +
    "            enable-download=\"model.EnableDownload\"\r" +
    "\n" +
    "            has-static-url=\"model.HasStaticUrl\"\r" +
    "\n" +
    "            document-download=\"downloadDocument(documentId)\"\r" +
    "\n" +
    "            document-get-static-url=\"getStaticUrl(documentId)\"\r" +
    "\n" +
    "            document-load=\"loadDocument(documentId, requestSettings)\"\r" +
    "\n" +
    "        ></ap-document-viewer-with-download>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/desktopRuler/views/apDesktopRuler.html',
    "<div class=\"container-fluid container-flush ap-application-margin ap-application-content desktop-ruler-height\">\r" +
    "\n" +
    "    <div class=\"desktop-ruler-margin-left\">P-L</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">01</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">02</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">03</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">04</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">05</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">06</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">07</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">08</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">09</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">10</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">11</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">12</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">13</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">14</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">15</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">16</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-margin-right\">P-R</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/footer/views/apFooter.html',
    "<div class=\"row print-bottom\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"ap-footer ap-application-padding\">\r" +
    "\n" +
    "        <div class=\"col-xs-4\">\r" +
    "\n" +
    "            <span class=\"hidden-print\">\r" +
    "\n" +
    "                 {{'Powered by' | translate}}&nbsp;&nbsp;\r" +
    "\n" +
    "                <img src=\"images/spacer.png\" class=\"ap-footer-logo\" alt=\"logo\">\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-8\">\r" +
    "\n" +
    "            <div class=\"row hidden-print\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <span class=\"pull-right\">\r" +
    "\n" +
    "                        <a class=\"clickable\" ng-click=\"contactUs()\">{{'Contact Us' | translate}}</a>\r" +
    "\n" +
    "                        &nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                        <a class=\"clickable\" ng-click=\"viewPrivacyPolicy()\">{{'Privacy Policy' | translate}}</a>\r" +
    "\n" +
    "                        <span ng-if=\"apFooter.PatientAuthenticated\">\r" +
    "\n" +
    "                            &nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                            <a class=\"clickable\" ng-click=\"viewPracticeTerms()\">{{'Practice Terms' | translate}}</a>\r" +
    "\n" +
    "                            &nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                            <a class=\"clickable\" ng-click=\"viewApiDocumentationGatekeeper()\">{{'API Documentation' | translate}}</a>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <span class=\"pull-right hidden-print\">\r" +
    "\n" +
    "                      &copy; {{'Aprima Medical Software 2015.  All rights reserved.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/header/views/apHeader.html',
    "\r" +
    "\n" +
    "<div class=\"ap-header flexbox flexbox-horizontal-center hidden-print\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"flexbox-pull-left\">\r" +
    "\n" +
    "        <span>\r" +
    "\n" +
    "            <img src=\"images/spacer.png\" class=\"header-image\" alt=\"header-logo\">\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "        <span class=\"header-title\" ng-if=\"apHeader.practiceName\">\r" +
    "\n" +
    "            {{apHeader.practiceName}}\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"header-dropdown header-menu header-item\" ng-show=\"!hideToolbar\">\r" +
    "\n" +
    "            <div uib-dropdown is-open='openmenu'>\r" +
    "\n" +
    "                <button class=\"btn btn-header btn-header-image\" type=\"button\" uib-dropdown-toggle>\r" +
    "\n" +
    "                    <span class=\"header-text1\">{{'Patient'|translate}}&nbsp;&nbsp;\r" +
    "\n" +
    "                        <img class=\"rounded-corner-sm border-width-sm extra-dark-grey-border\"\r" +
    "\n" +
    "                             lazy-src=\"{{apHeader.activePatientId | apPatientPortalThumbnailSrc:30:30}}\" endpoint-base='patient' alt=\"patient-image\"/>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                    <span class=\"header-text2\">&nbsp;&nbsp;{{apHeader.activePatientFullName}} </span>\r" +
    "\n" +
    "                    <span ng-if=\"apHeader.hasResponsibleParties\" class=\"caret\"></span>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <ul ng-if=\"apHeader.hasResponsibleParties\" class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\r" +
    "\n" +
    "                    <li ng-repeat=\"patient in apHeader.responsibleParties\" role=\"presentation\" ng-click=\"setActivePatient(patient)\" ng-if=\"patient\">\r" +
    "\n" +
    "                        <a role=\"menuitem\" >\r" +
    "\n" +
    "                            <img class=\"rounded-corner-md border-width-md extra-dark-grey-border\"\r" +
    "\n" +
    "                                                 lazy-src=\"{{patient.Id | apPatientPortalThumbnailSrc:40:40}}\" endpoint-base='patient' alt=\"patient-image\"/>&nbsp;&nbsp;{{patient.FirstName}} {{patient.LastName}}</a>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"header-dropdown header-menu header-item flush-right\" ng-show=\"!hideToolbar\">\r" +
    "\n" +
    "            <div uib-dropdown>\r" +
    "\n" +
    "                <button class=\"btn btn-header btn-flush-right btn-header-image no-image\" type=\"button\" id=\"header-context-menu\" uib-dropdown-toggle>\r" +
    "\n" +
    "                    <span class=\"header-text1\">{{'Welcome,'|translate}}&nbsp;&nbsp;</span>\r" +
    "\n" +
    "                    <span class=\"header-text2\">{{apHeader.loginUserFullName}} </span>\r" +
    "\n" +
    "                    <span class=\"caret\"></span>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <ul class=\"dropdown-menu dropdown-menu-right no-image\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"header-context-menu\">\r" +
    "\n" +
    "                    <li role=\"presentation\">\r" +
    "\n" +
    "                        <a id=\"context-update-notifications\" role=\"menuitem\" tabindex=\"1\" ng-click=\"updateNotifications()\">{{'Update Notifications' | translate}}</a>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                    <li role=\"presentation\">\r" +
    "\n" +
    "                        <a id=\"context-signout\" role=\"menuitem\" tabindex=\"3\" ng-click=\"signOff()\">{{'Sign Out' | translate}}</a>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"ap-mobile-menu-button\" ng-click=\"toggleMobileNav()\">\r" +
    "\n" +
    "            <span class=\"glyphicon glyphicon-menu-hamburger\"></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <span class = \"header-item pull-right center-text\" ng-if=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/mobileNav/views/apMobileNav.html',
    "<!--Begin mobile nav bar-->\r" +
    "\n" +
    "<div class=\"ap-mobile-nav slide-in\" uib-dropdown uib-collapse=\"!showMobileNav\" ng-cloak>\r" +
    "\n" +
    "  <div ng-if=\"showMobileNav\">\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'dashboard'})\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg home-selected\" src=\"images/spacer.png\" ng-if=\"(!toolbarItem || (toolbarItem == 'welcome'))\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg home\" src=\"images/spacer.png\" ng-if=\"(toolbarItem && (toolbarItem != 'welcome'))\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': (!toolbarItem || (toolbarItem == 'welcome')) }\">\r" +
    "\n" +
    "        {{:: 'Welcome' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'myChartMobile', opts: {openPD: 'false'}})\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg chart-selected\" src=\"images/spacer.png\" ng-if=\"(toolbarItem == 'chart')\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg chart\" src=\"images/spacer.png\" ng-if=\"(toolbarItem != 'chart')\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'chart' }\">\r" +
    "\n" +
    "        {{:: 'Chart' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"badge\" ng-if=\"notifications.Chart.BadgeCount > 0\">{{notifications.Chart.BadgeCount}}</span>\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'myMessagesMobile', opts: {displayMode: 'received'}})\" ng-show=\"notifications.Messages.IsActive\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg messages-selected\" src=\"images/spacer.png\" ng-if=\"(toolbarItem == 'messages')\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg messages\" src=\"images/spacer.png\" ng-if=\"(toolbarItem != 'messages')\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'messages' }\">\r" +
    "\n" +
    "        {{:: 'Messages' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"badge\" ng-if=\"notifications.Messages.BadgeCount > 0\">{{notifications.Messages.BadgeCount}}</span>\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'prescriptionsMobile'})\" ng-show=\"notifications.Prescriptions.IsActive\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg prescriptions-selected\" src=\"images/spacer.png\" ng-if=\"(toolbarItem == 'prescriptions')\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg prescriptions\" src=\"images/spacer.png\" ng-if=\"(toolbarItem != 'prescriptions')\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'prescriptions' }\">\r" +
    "\n" +
    "        {{:: 'Prescriptions' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"badge\" ng-if=\"notifications.Prescriptions.BadgeCount > 0\">{{notifications.Prescriptions.BadgeCount}}</span>\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'forms'})\" ng-show=\"notifications.Forms.IsActive\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg forms-selected\" src=\"images/spacer.png\" ng-if=\"(toolbarItem == 'forms')\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg forms\" src=\"images/spacer.png\" ng-if=\"(toolbarItem != 'forms')\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'forms' }\">\r" +
    "\n" +
    "        {{:: 'Forms' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"badge\" ng-if=\"notifications.Forms.BadgeCount > 0\">{{notifications.Forms.BadgeCount}}</span>\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'myAppointments'})\" ng-show=\"notifications.Appointments.IsActive\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg appointments-selected\" src=\"images/spacer.png\" ng-if=\"(toolbarItem == 'appointments')\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg appointments\" src=\"images/spacer.png\" ng-if=\"(toolbarItem != 'appointments')\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'appointments' }\">\r" +
    "\n" +
    "        {{:: 'Appointments' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"badge\" ng-if=\"notifications.Appointments.BadgeCount > 0\">{{notifications.Appointments.BadgeCount}}</span>\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'billing'})\" ng-show=\"notifications.Billing.IsActive\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg billing-selected\" src=\"images/spacer.png\" ng-if=\"(toolbarItem == 'billing')\">\r" +
    "\n" +
    "        <img class=\"toolbar-svg billing\" src=\"images/spacer.png\" ng-if=\"(toolbarItem != 'billing')\">\r" +
    "\n" +
    "      <span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'billing' }\">\r" +
    "\n" +
    "        {{:: 'Billing' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"badge\" ng-if=\"notifications.Billing.BadgeCount > 0\">{{notifications.Billing.BadgeCount}}</span>\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <!--<div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-click=\"transitionAndCloseNav({appRoute: 'navigationDoctors'})\">-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <!--<img class=\"toolbar-svg\" src=\"images/doctors-selected.svg\" ng-if=\"(toolbarItem == 'doctors')\">-->\r" +
    "\n" +
    "        <!--<img class=\"toolbar-svg\" src=\"images/doctors.svg\" ng-if=\"(toolbarItem != 'doctors')\">-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "      <!--<span class=\"nav-item\" ng-class=\"{'nav-item-active': toolbarItem == 'doctors' }\">-->\r" +
    "\n" +
    "        <!--{{:: 'Doctors' | translate}}-->\r" +
    "\n" +
    "      <!--</span>-->\r" +
    "\n" +
    "      <!--<span class=\"flexbox-pull-right\">-->\r" +
    "\n" +
    "        <!--<span class=\"badge\" ng-if=\"notifications.Doctors.BadgeCount > 0\">{{notifications.Doctors.BadgeCount}}</span>-->\r" +
    "\n" +
    "      <!--</span>-->\r" +
    "\n" +
    "    <!--</div>-->\r" +
    "\n" +
    "    \r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item ap-mobile-nav-welcome flexbox flexbox-horizontal-center\" ng-if=\"headerData && headerData.activePatientId\">\r" +
    "\n" +
    "        {{:: 'Welcome' | translate}}, {{ ::headerData.loginUserFullName }}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    \r" +
    "\n" +
    "    <div ng-if=\"headerData && headerData.hasResponsibleParties\">\r" +
    "\n" +
    "        <div class=\"ap-mobile-nav-item flexbox flexbox-horizontal-center\" ng-repeat=\"party in headerData.responsibleParties | filter: {Id: '!' + headerData.activePatientId }\">\r" +
    "\n" +
    "            <span class=\"nav-item\" ng-click=\"setActivePatient(party.Id)\">\r" +
    "\n" +
    "                {{:: 'Switch to' | translate }} {{ ::party.FirstName }} {{ ::party.LastName }}\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item ap-mobile-nav-signout flexbox flexbox-horizontal-center\" ng-click=\"signOff()\">\r" +
    "\n" +
    "      <i class=\"fa fa-power-off\"></i>\r" +
    "\n" +
    "      <span class=\"nav-item\">\r" +
    "\n" +
    "        {{:: 'Sign out' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "  </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/partials/toolbar/views/apToolbar.html',
    "<div class=\"btn-group btn-group-justified ap-toolbar ap-application-margin ap-application-content hidden-print\" role=\"group\" ng-cloak>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group-toolbar-blank flexbox flexbox-horizontal-center\" ng-if=\"blankToolbar.IsActive\">\r" +
    "\n" +
    "            <button\r" +
    "\n" +
    "                    ng-if=\"blankToolbar.BackToHome.IsActive\"\r" +
    "\n" +
    "                    class=\"btn btn-nowrap btn-toolbar\"\r" +
    "\n" +
    "                    id=\"back-to-home-btn\"\r" +
    "\n" +
    "                    ng-click=\"backToHome()\">\r" +
    "\n" +
    "                <div class=\"underline-blank-toolbar\">\r" +
    "\n" +
    "                    <i class=\"fa fa-backward\"></i>&nbsp;{{:: 'Back to Home' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(!toolbarItem || toolbarItem === 'welcome')? 'btn-group-toolbar-selected btn-group-flush-left' : 'btn-group-toolbar btn-group-flush-left'\"\r" +
    "\n" +
    "             role=\"group\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"welcome-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Welcome.IsActive && !blankToolbar.BackToHome.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'dashboard'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg home-selected\" ng-if=\"(!toolbarItem || toolbarItem === 'welcome')\" alt=\"home-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg home\" ng-if=\"(toolbarItem && toolbarItem !== 'welcome')\" alt=\"home\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Welcome' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'chart')? 'btn-group-toolbar-selected' : 'btn-group-toolbar'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Chart.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"chart-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Chart.IsActive\"\r" +
    "\n" +
    "                        ng-click=\"navigateToChart()\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg chart-selected\" ng-if=\"toolbarItem == 'chart'\" alt=\"chart-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg chart\" ng-if=\"toolbarItem != 'chart'\" alt=\"chart\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Chart' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" ng-if=\"notifications.Chart.BadgeCount > 0\">{{notifications.Chart.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'messages')? 'btn-group-toolbar-selected' : 'btn-group-toolbar'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Messages.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"messages-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Messages.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myMessagesDisplayMessages', opts: {displayMode: 'received'}}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg messages-selected\" ng-if=\"toolbarItem == 'messages'\" alt=\"messages-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg messages\" ng-if=\"toolbarItem != 'messages'\" alt=\"messages\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Messages' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" ng-if=\"notifications.Messages.BadgeCount > 0\">{{notifications.Messages.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'forms')? 'btn-group-toolbar-selected' : 'btn-group-toolbar'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Forms.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"forms-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Forms.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'forms'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg forms-selected\" ng-if=\"toolbarItem == 'forms'\" alt=\"forms-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg forms\" ng-if=\"toolbarItem != 'forms'\" alt=\"forms\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Forms' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" id=\"froms-badge-count\" ng-if=\"notifications.Forms.BadgeCount > 0\">{{notifications.Forms.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'prescriptions')? 'btn-group-toolbar-selected' : 'btn-group-toolbar'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Prescriptions.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"prescriptions-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Prescriptions.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'prescriptions'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg prescriptions-selected\" ng-if=\"toolbarItem == 'prescriptions'\" alt=\"prescriptions-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg prescriptions\" ng-if=\"toolbarItem != 'prescriptions'\" alt=\"prescriptions\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Prescriptions' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" ng-if=\"notifications.Prescriptions.BadgeCount > 0\">{{notifications.Prescriptions.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'appointments')? 'btn-group-toolbar-selected' : 'btn-group-toolbar'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Appointments.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"appointments-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Appointments.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'myAppointments'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg appointments-selected\" ng-if=\"toolbarItem == 'appointments'\" alt=\"appointments-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg appointments\" ng-if=\"toolbarItem != 'appointments'\" alt=\"appointments\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Appointments' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" ng-if=\"notifications.Appointments.BadgeCount > 0\">{{notifications.Appointments.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'billing')? 'btn-group-toolbar-selected btn-group-flush-right' : 'btn-group-toolbar btn-group-flush-right'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Billing.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"billing-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Billing.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'billing'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg billing-selected\" ng-if=\"toolbarItem == 'billing'\" alt=\"billing-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg billing\" ng-if=\"toolbarItem != 'billing'\" alt=\"billing\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Billing' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" ng-if=\"notifications.Billing.BadgeCount > 0\">{{notifications.Billing.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(toolbarItem == 'doctors')? 'btn-group-toolbar-selected' : 'btn-group-toolbar'\"\r" +
    "\n" +
    "             role=\"group\"\r" +
    "\n" +
    "             ng-if=\"notifications.Doctors.IsActive && !blankToolbar.BackToHome.IsActive\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"doctors-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Doctors.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'navigationDoctors'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg doctors-selected\" ng-if=\"toolbarItem == 'doctors'\" alt=\"doctors-selected\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg doctors\" ng-if=\"toolbarItem != 'doctors'\" alt=\"doctors\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Doctors' | translate}}&nbsp;\r" +
    "\n" +
    "                        <span class=\"badge\" ng-if=\"notifications.Doctors.BadgeCount > 0\">{{notifications.Doctors.BadgeCount}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>"
  );

}]);
